var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashred(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3575_19445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.72493 0.908203H4.54165M0.908203 1.81656H6.35837M5.7528 1.81656L5.54046 5.00167C5.5086 5.47954 5.49267 5.71848 5.38946 5.89965C5.29859 6.05915 5.16153 6.18738 4.99633 6.26744C4.8087 6.35837 4.56923 6.35837 4.0903 6.35837H3.17628C2.69734 6.35837 2.45788 6.35837 2.27024 6.26744C2.10505 6.18738 1.96798 6.05915 1.87712 5.89965C1.7739 5.71848 1.75798 5.47954 1.72612 5.00167L1.51378 1.81656M3.02771 3.17911V4.69304M4.23886 3.17911V4.69304",
    stroke: "#F04438",
    strokeWidth: 0.605574,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3575_19445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.26689,
    height: 7.26689,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashred);
export default __webpack_public_path__ + "static/media/trashred.38df3c80d1818a4ee5254a861533e380.svg";
export { ForwardRef as ReactComponent };